const garSubscription = {
  garSubscriptions: "Abonnements GAR",
  subscriptionDetails: "Détails de l'abonnement",
  subscriptionUpdate: "Modification de l'abonnement",
  updateWarning:
    "Attention : dès lors qu'un abonnement a débuté, les seules modifications autorisées sont pour prolonger la date de fin d’abonnement ou pour augmenter le nombre de licences.",
  title: "Abonnements des établissements GAR",
  startValidity: "Début de l'abonnement",
  endValidity: "Fin de l'abonnement",
  affectationType: "Type d'affectation",
  licences: "Licences",
  subscribeEstablishment: "Abonner un établissement du GAR",
  projectCode: "Code de projet",
  projectCodeError:
    "Le code projet fourni n'existe pas, il n'a donc pas été sauvegardé.",
  maxSubscriptionStart:
    "La date de début de validité d’un abonnement ne peut pas dépasser 10 ans par rapport à la date de création de l’abonnement.",
  searchEstablishment: "Rechercher un établissement",
  estNameOrUAI: "Nom de l'établissement ou UAI",
  deptNumber: "Numéro département (optionnel)",
  searchNoResult: "Aucun établissement ne correspond à votre recherche.",
  licencesType: "Type de licences",
  global: "Globale",
  targetPublic: "Par public cible",
  nbGlobalLicences: "Nb licences globales",
  nbStudentLicences: "Nb licences élèves",
  nbTeacherLicences: "Nb licences enseignants",
  nbProfDocLicences: "Nb licences enseignants-documentalistes",
  nbOtherStaffLicences: "Nb licences autre personnel",
  unlimited: "Illimitées",
  OR: "OU",
  deleteSubscription: "Supprimer l'abonnement",
  deleteSubscriptionVerif: "Supprimer cet abonnement ?",
};

export default garSubscription;
